import { useMetadata } from "@/hooks/useMetadata";
import { LegalDocument } from "../LegalDocument";
import { sections } from "./sections";

export default function PrivacyPolicyPage() {
  useMetadata({
    title: "Mohtawa Creative OS Privacy Policy",
    description:
      "Everything about your privacy on Mohtawa Creative OS in one space",
  });

  return (
    <LegalDocument
      title="Mohtawa Creative OS Privacy Policy"
      updated="Updated July 12, 2026"
      sections={sections}
      intro={
        <p>
          All information provided by Users of the{" "}
          <a href="https://mohtawa.ai">Mohtawa Creative OS</a> platform (
          <a href="https://mohtawa.ai">mohtawa.ai</a>) is processed in
          accordance with this Mohtawa Creative OS Privacy Policy (hereinafter —
          the Policy).
          <br />
          This Policy is based on current data protection legislation and sets
          out how we act to protect your personal data.
        </p>
      }
    />
  );
}
